"use client";

import dynamic from "next/dynamic";

import type { TrustArcProps } from "./trustArc.component";

export const TrustArcContainer = dynamic<TrustArcProps>(
  () => import("./trustArc.component"),
  {
    ssr: false,
  },
);
